import { useSyncExternalStore } from 'react';

import {
  getPageHeaderInfoState,
  subscribeToPageHeaderInfoState,
} from 'bundles/composable-page-header/stores/PageHeaderInfoStore';

export const usePageHeaderInfoState = () => {
  return useSyncExternalStore(subscribeToPageHeaderInfoState, getPageHeaderInfoState, getPageHeaderInfoState);
};
